import { useEffect, useRef } from "react";
import { MapContainer, Marker, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";
import { BR_CENTER, Tiles, dot } from "@/components/delivery/mapParts";
import { cn } from "@/lib/utils";
import { MovingMarker } from "./MovingMarker";

const MOTO = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="17" r="3"/><circle cx="18.5" cy="17" r="3"/><path d="M5.5 17 9 11h6l3.5 6"/><path d="M15 11l-2-5h3"/><path d="M8 8h3"/></svg>';

export const courierIcon = L.divIcon({
  className: "",
  html: `<span style="position:relative;display:flex;width:38px;height:38px"><span class="animate-ping" style="position:absolute;inset:0;border-radius:50%;background:rgba(37,99,235,.35)"></span><span style="position:relative;display:flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:50%;background:#2563eb;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.45)">${MOTO}</span></span>`,
  iconSize: [38, 38], iconAnchor: [19, 19],
});

function FitPoints({ points }) {
  const map = useMap();
  const seen = useRef(0);
  const key = points.map((p) => p.join(",")).join("|");
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 300);
    return () => clearTimeout(t);
  }, [map]);
  useEffect(() => {
    if (points.length <= seen.current) return;
    seen.current = points.length;
    if (points.length === 1) map.setView(points[0], 16);
    else map.fitBounds(points, { padding: [40, 40], maxZoom: 16 });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return null;
}

export function TrackMap({ store, dest, courier, courierLabel, className = "h-[320px]" }) {
  const pts = [store, dest, courier].filter(Boolean);
  return (
    <div className="isolate overflow-hidden rounded-xl border" data-testid="track-map">
      <MapContainer center={pts[0] || BR_CENTER} zoom={pts.length ? 15 : 4} className={cn("w-full", className)}>
        <Tiles />
        {store && <Marker position={store} icon={dot("#0f172a", 20)}><Tooltip direction="top">Loja</Tooltip></Marker>}
        {dest && <Marker position={dest} icon={dot("#dc2626", 20)}><Tooltip direction="top">Entrega</Tooltip></Marker>}
        {courier && <MovingMarker position={courier} icon={courierIcon}><Tooltip direction="top">{courierLabel}</Tooltip></MovingMarker>}
        <FitPoints points={pts} />
      </MapContainer>
    </div>
  );
}
